import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faInfoCircle, faRocket } from "@fortawesome/free-solid-svg-icons";
import "./TestTimePageStyle.css";

interface Actions {
  onConfirmClick: () => void;
}

interface Props {
  actions: Actions;
}

const TestTimePageView: React.FC<Props> = ({ actions }) => {
  return (
    <div className="ja-testtime-pageWrapper">
      <div className="ja-testtime-mainContainer">
        
        {/* Header Icon & Titel */}
        <div className="ja-testtime-header">
          <div className="ja-testtime-iconWrapper">
            <FontAwesomeIcon icon={faRocket} />
          </div>
          <h2>Willkommen bei JuniorAlarm!</h2>
          <p className="ja-testtime-subtitle">
            Starten Sie jetzt unverbindlich in Ihren Testzeitraum.
          </p>
        </div>

        {/* Info Card */}
        <div className="ja-testtime-card">
          <div className="ja-testtime-cardHeader">
            <FontAwesomeIcon icon={faInfoCircle} className="ja-testtime-cardIcon" />
            <h3>4 Kostenlose Testalarme</h3>
          </div>
          
          <div className="ja-testtime-cardBody">
            <p>
              Wir freuen uns, Ihnen mitteilen zu können, dass Sie JuniorAlarm jetzt
              mit <strong>4 kostenlosen Testalarmen</strong> ausprobieren können! Nutzen Sie diese
              Gelegenheit, um alle Funktionen unseres Dienstes ohne Verpflichtungen zu testen.
            </p>
            <p>
              Nach Ablauf der 4 kostenlosen Testalarme ist eine Freischaltung erforderlich,
              um weiterhin uneingeschränkten Zugang zu allen Funktionen zu erhalten.
            </p>
            <p>
              Wir sind überzeugt, dass JuniorAlarm Ihnen wertvolle Dienste leisten wird,
              und freuen uns darauf, Sie unterstützen zu dürfen!
            </p>
          </div>

          <div className="ja-testtime-actionArea">
            <button
              type="button"
              className="ja-login-primaryButton ja-testtime-confirmBtn"
              onClick={actions.onConfirmClick}
            >
              <FontAwesomeIcon icon={faCheck} />
              <span>Verstanden &amp; Weiter</span>
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="ja-testtime-footer">
          <p>&copy; {new Date().getFullYear()} MBSoftwareSolutions. Alle Rechte vorbehalten.</p>
        </div>

      </div>
    </div>
  );
};

export default TestTimePageView;